import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  inject,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { NotificationButtonStyle, NotificationTheme } from '@fcom/ui-components';
import { StepperStep } from '@fcom/ui-components/components/stepper/interfaces';
import { StepperTheme } from '@fcom/ui-components/components/stepper/enums';
import { findScrollContainer } from '@fcom/core';

@Component({
  selector: 'fin-login-form-container',
  templateUrl: './login-form-container.component.html',
  styleUrls: ['./login-form-container.component.scss'],
  standalone: false,
})
export class LoginFormContainerComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  private cd = inject(ChangeDetectorRef);
  private renderer = inject(Renderer2);
  private document = inject<Document>(DOCUMENT);
  private elementRef = inject(ElementRef);

  readonly NotificationTheme = NotificationTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly StepperTheme = StepperTheme;
  readonly NotificationButtonStyle = NotificationButtonStyle;

  readonly bottomMargin = 20;

  @ViewChild('dialogTitle') dialogTitle: ElementRef;
  @ViewChild('loginContainer') loginContainer: ElementRef;

  @Input()
  fullScreen = false;
  @Input()
  invertHeaderColors = false;
  @Input()
  closable = true;

  /**
   * A boolean flag indicating whether to use a compact representation
   * which removes some paddings and margins
   */
  @Input()
  compact = false;
  @Input()
  icon: SvgLibraryIcon;
  @Input()
  title: string;
  @Input()
  description: string;
  @Input()
  error: string;
  @Input()
  errorLinkText: string;
  @Input()
  stepperSteps$: Observable<StepperStep[]>;
  @Input()
  stepperActiveStep$: Observable<number>;
  @Input()
  overlay = false;
  @Input()
  showLeftIcon = false;

  @Output()
  stepperClicked: EventEmitter<StepperStep> = new EventEmitter<StepperStep>();

  @Output()
  returnClicked = new EventEmitter<Event>();
  @Output()
  closeClicked = new EventEmitter<Event>();
  @Output()
  alertNotificationLinkClicked = new EventEmitter<Event>();

  availableHeight: number;
  containerHeight = 'auto';
  containerOverflow = 'unset';
  private lastHeight: string;

  ngOnInit(): void {
    this.availableHeight = this.document.documentElement.clientHeight;
    this.renderer.addClass(this.document.body, 'modal-open-laptop-down');
    this.renderer.addClass(
      findScrollContainer(this.elementRef.nativeElement) || this.document.documentElement,
      'ios-scroll-touch'
    );

    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'modal-open-laptop-down');
    this.renderer.removeClass(
      findScrollContainer(this.elementRef.nativeElement) || this.document.documentElement,
      'ios-scroll-touch'
    );
    this.cd.detectChanges();
  }

  ngAfterViewInit(): void {
    this.dialogTitle.nativeElement.focus();
    const containerYPos = this.loginContainer.nativeElement.getBoundingClientRect().top;
    this.availableHeight = this.availableHeight - containerYPos;
  }

  ngAfterViewChecked(): void {
    const containerHeight = this.loginContainer?.nativeElement.clientHeight || 0;

    const isOverflowing = this.availableHeight < containerHeight;
    const newHeight = isOverflowing ? `${this.availableHeight - this.bottomMargin}px` : 'auto';
    this.containerOverflow = isOverflowing ? 'auto' : 'unset';

    if (newHeight !== this.lastHeight) {
      this.containerHeight = newHeight;
      this.lastHeight = newHeight;
      this.cd.detectChanges();
    }
  }
}
